import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import './assets/css/main.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'vue-multiselect/dist/vue-multiselect.css';

import VCalendar from 'v-calendar'
import 'v-calendar/style.css'

import './plugins/vee-validate'

import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import { DefaultApolloClient } from '@vue/apollo-composable'
import apolloClient from './apolloClient'

const toastOptions = {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  toastClassName: "custom-toast"
}

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app
  .use(pinia)
  .use(router)
  .use(VCalendar, {})
  .use(Toast, toastOptions)
  .provide(DefaultApolloClient, apolloClient)
  .mount("#app");
